export type ThemeBreakpointName = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

export const Breakpoints: Record<ThemeBreakpointName, number> = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
  '2xl': 1536,
  '3xl': 1920,
};

export const Screens: Record<ThemeBreakpointName, string> = {
  xs: `${Breakpoints.xs}px`,
  sm: `${Breakpoints.sm}px`,
  md: `${Breakpoints.md}px`,
  lg: `${Breakpoints.lg}px`,
  xl: `${Breakpoints.xl}px`,
  '2xl': `${Breakpoints['2xl']}px`,
  '3xl': `${Breakpoints['3xl']}px`,
};
